export default __webpack_public_path__ + "static/media/Vest of the Hell Walker.37918df1.jpg";